// Función para formatear fechas ISO a formato legible
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  } catch (e) {
    return 'N/A';
  }
};

// Función para decodificar HTML entities en direcciones
export const decodeAddress = (addressData) => {
  if (!addressData) return 'N/A';
  return addressData
    .replace(/&amp;#xa;/g, '\n')
    .replace(/&amp;/g, '&')
    .replace(/&#xa;/g, '\n');
};

// Función para formatear salario
export const formatSalary = (salary) => {
  if (!salary || salary === 0) return 'N/A';
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(salary);
};

// Función para formatear teléfono
export const formatPhone = (phone) => {
  if (!phone || phone === 'none' || phone === '') return 'N/A';
  return phone;
};
